/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrangeSendToBack: {
  name: 'arrange-send-to-back';
  data: string;
} = {
  name: 'arrange-send-to-back',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h6v6H4V4Zm10 8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-6Zm0 2h6v6h-6v-6Zm1-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
